module.exports = __webpack_public_path__ + "img/pic7-2.c5cb4b51.png";